export default __webpack_public_path__ + "static/media/doc_icon.5583f2e0.svg";